/* eslint-disable jsx-a11y/iframe-has-title */

/* eslint-disable react/jsx-no-comment-textnodes */
import { LinkElement } from '@/cmsComponents/LinkElement';
import { MarkdownCMSModule } from '@/cmsComponents/MarkdownCMSModule';
import { Alignment } from '@/cmsComponents/constants';
import cx from 'classnames';
import Image from 'next/image';
import React from 'react';
import { IVideoText } from 'types/cms';
import { getVideoId } from 'utils/parseYoutubeUrl';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import { VideoTextStyle } from '.';
import styles from './style.module.scss';

export const YOUTUBE_URL_PREFIX = 'https://www.youtube.com/embed/';

export interface VideoTextProps {
  data: IVideoText;
  style: VideoTextStyle;
  alignment: Alignment;
}

type VideoProps = {
  youtube_url: string;
};

const DisplayVideoOrThumb = ({ youtube_url }: VideoProps) => {
  const [showVideo, setShowVideo] = React.useState(false);

  return (
    <>
      {showVideo ? (
        <iframe
          className={styles.videoPlayer}
          src={`${YOUTUBE_URL_PREFIX}${getVideoId(youtube_url)}`}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      ) : (
        <div
          className={cx(styles.videoPlayer, styles.videoThumb)}
          onClick={() => setShowVideo(true)}
        >
          <div className={styles['arrow-right']}></div>
          <Image
            className={styles.videoThumb}
            src={`https://img.youtube.com/vi/${getVideoId(youtube_url)}/maxresdefault.jpg`}
            alt="video thumbnail"
            width={924}
            height={590}
            data-testid="video-thumb"
          />
        </div>
      )}
    </>
  );
};

export const Item = ({ data, style, alignment }: VideoTextProps) => {
  const { title, video, blurb, button_style, button_URL, button_text, youtube_url } = data;
  return (
    <div className={styles[alignment]}>
      {title && style !== VideoTextStyle.VideoLeft && (
        <Typography variant="h5" component="h3" className={styles.title}>
          {title}
        </Typography>
      )}
      <Grid
        container
        direction={style === VideoTextStyle.VideoLeft ? 'row' : 'column'}
        spacing={3}
        className={styles.itemContainer}
      >
        <Grid item xs={12} md>
          {youtube_url ? (
            <div className={styles.videoPlayer}>
              <DisplayVideoOrThumb youtube_url={youtube_url} />
            </div>
          ) : (
            <video controls className={styles.videoPlayer}>
              <track kind="captions" />
              <source src={video?.url} />
            </video>
          )}
        </Grid>
        <Grid item xs={12} md>
          <div className={styles.content}>
            {title && style === VideoTextStyle.VideoLeft && (
              <Typography variant="h5" className={styles.title}>
                {title}
              </Typography>
            )}
            {blurb && (
              <div className={styles.blurb}>
                <MarkdownCMSModule source={blurb} />
              </div>
            )}
            {button_URL && (
              <LinkElement
                link={button_URL}
                linkStyle={button_style}
                linkText={button_text}
                align={style === VideoTextStyle.VideoLeft ? Alignment.Left : alignment}
              />
            )}
          </div>
        </Grid>
      </Grid>
    </div>
  );
};
